/**
 * Pont Google Consent Mode v2 <-> Shopify Customer Privacy API.
 *
 * L'état par défaut (« denied ») est posé de façon synchrone AVANT GTM par le snippet
 * « snippets/google-consent-mode.liquid ». Ce fichier lit le consentement collecté par le bandeau
 * natif Shopify et le transmet à Google via gtag('consent','update', …).
 *
 * Deux cas gérés :
 *   - Visiteur récurrent / région sans consentement requis : lecture de l'état courant via l'API.
 *   - Nouveau visiteur qui accepte/refuse : écoute de l'événement document « visitorConsentCollected ».
 *
 * Expose pour les autres scripts (Klaviyo) :
 *   - window.__marketingConsentGranted() -> boolean
 *   - un événement document « rodhouse:consent-updated » à chaque mise à jour du consentement.
 */
(function () {
  'use strict';

  var lastMarketingGranted = false;

  window.__marketingConsentGranted = function () {
    return lastMarketingGranted === true;
  };

  function gtagUpdate(consent) {
    var marketing = consent.marketing === true;
    var analytics = consent.analytics === true;
    var preferences = consent.preferences === true;

    if (typeof window.gtag === 'function') {
      window.gtag('consent', 'update', {
        'ad_storage': marketing ? 'granted' : 'denied',
        'ad_user_data': marketing ? 'granted' : 'denied',
        'ad_personalization': marketing ? 'granted' : 'denied',
        'analytics_storage': analytics ? 'granted' : 'denied',
        'functionality_storage': preferences ? 'granted' : 'denied',
        'personalization_storage': preferences ? 'granted' : 'denied'
      });
    }
  }

  function apply(consent) {
    lastMarketingGranted = consent.marketing === true;
    gtagUpdate(consent);

    document.dispatchEvent(
      new CustomEvent('rodhouse:consent-updated', { detail: consent })
    );
  }

  function fromApi(cp) {
    return {
      marketing: cp.marketingAllowed(),
      analytics: cp.analyticsProcessingAllowed(),
      preferences: cp.preferencesProcessingAllowed(),
      saleOfData: cp.saleOfDataAllowed()
    };
  }

  function fromEvent(detail) {
    detail = detail || {};
    return {
      marketing: !!detail.marketingAllowed,
      analytics: !!detail.analyticsAllowed,
      preferences: !!detail.preferencesAllowed,
      saleOfData: !!detail.saleOfDataAllowed
    };
  }

  // Changements en direct via le bandeau (l'événement ne se déclenche QUE quand le consentement change).
  document.addEventListener('visitorConsentCollected', function (event) {
    apply(fromEvent(event.detail));
  });

  // État initial : lu via l'API pour couvrir le visiteur récurrent qui a déjà consenti
  // (l'événement ci-dessus ne se redéclenche pas au chargement).
  function loadInitialConsent() {
    if (!window.Shopify || typeof window.Shopify.loadFeatures !== 'function') {
      return false;
    }

    window.Shopify.loadFeatures(
      [{ name: 'consent-tracking-api', version: '0.1' }],
      function (error) {
        if (error) return;
        var cp = window.Shopify.customerPrivacy;
        if (cp && typeof cp.marketingAllowed === 'function') {
          apply(fromApi(cp));
        }
      }
    );

    return true;
  }

  if (!loadInitialConsent()) {
    var tries = 0;
    var timer = setInterval(function () {
      tries += 1;
      if (loadInitialConsent() || tries > 50) {
        clearInterval(timer);
      }
    }, 100);
  }
})();
